import { render, staticRenderFns } from "./imageBannerSettingLR.vue?vue&type=template&id=5833ee1c&scoped=true&"
import script from "./imageBannerSettingLR.vue?vue&type=script&lang=js&"
export * from "./imageBannerSettingLR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5833ee1c",
  null
  
)

export default component.exports